function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import utils from '../../../common/utils/index.js';
import { GalleryComponent } from '../../galleryComponent';
import { isSiteMode, isSEOMode } from '../../../common/window/viewModeWrapper';
import EVENTS from '../../../common/constants/events';

var Share =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(Share, _GalleryComponent);

  function Share(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.getShareArr = _this.getShareArr.bind(_assertThisInitialized(_this));
    _this.buttons = [];
    _this.shareArr = _this.getShareArr(_this.props.type);
    _this.state = {
      showShare: false,
      focusedShareIcon: 0
    };
    return _this;
  }

  var _proto = Share.prototype;

  _proto.getShareArr = function getShareArr(type) {
    return type === 'text' ? ['facebook', 'twitter', 'tumblr', 'email'] : ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];
  };

  _proto.handleKeyDown = function handleKeyDown(e, type) {
    if (this.state.showShare) {
      switch (e.keyCode || e.charCode) {
        case 38: //up

        case 37: //left

        case 33:
          //page up
          e.preventDefault();
          e.stopPropagation();
          utils.setStateAndLog(this, 'Share Keypress', {
            focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
          });
          return false;

        case 39: //right

        case 40: //down

        case 34:
          //page down
          e.preventDefault();
          e.stopPropagation();
          utils.setStateAndLog(this, 'Share Keypress', {
            focusedShareIcon: Math.min(type === 'text' ? 4 : 5, this.state.focusedShareIcon + 1)
          });
          return false;

        case 9: //tab

        case 27:
          //esc
          e.preventDefault();
          e.stopPropagation();
          this.props.actions.toggleShare(e, false);
          utils.setStateAndLog(this, 'Share Keypress', {
            showShare: false,
            focusedShareIcon: 0
          });
          return false;
      }
    }

    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();
        e.stopPropagation();

        if (this.state.showShare) {
          var allProps = this.props.allProps;
          var shareData = {
            network: this.shareArr[this.state.focusedShareIcon - 1],
            shareProps: allProps
          };
          this.props.actions.eventsListener(EVENTS.SHARE_BUTTON_CLICKED, shareData);
          this.props.actions.toggleShare(e, false);
          utils.setStateAndLog(this, 'Share Keypress', {
            showShare: false,
            focusedShareIcon: 0
          });
        } else {
          this.props.actions.toggleShare(e, true);
          utils.setStateAndLog(this, 'Share Keypress', {
            showShare: true,
            focusedShareIcon: 1
          });
        }

        return false;
    }

    return true;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.showShare && !this.state.showShare) {
      utils.setStateAndLog(this, 'props.showShare is true', {
        showShare: true
      });
    } else if (!this.props.showShare && this.state.showShare) {
      utils.setStateAndLog(this, 'props.showShare is false', {
        showShare: false
      });
    }

    try {
      if ((isSiteMode() || isSEOMode()) && !utils.isMobile() && window.document && window.document.activeElement && window.document.activeElement.className) {
        var activeElement = window.document.activeElement;

        var isShareItemInFocus = function isShareItemInFocus() {
          return String(activeElement.className).indexOf('network-') >= 0;
        };

        if (!this.state.showShare && isShareItemInFocus()) {
          this.socialShareBox.focus();
          return;
        }
      }

      var focusedButton = this.state.focusedShareIcon;

      if (focusedButton > 0) {
        this.buttons[focusedButton - 1].focus();
      }
    } catch (e) {
      console.warn('Cannot focus on share icon', this.props.focus, e);
    }
  };

  _proto.getShareItem = function getShareItem(network, idx) {
    var _this2 = this;

    var allProps = this.props.allProps;
    var shareIconsNumber = this.shareArr.length;
    return React.createElement("button", {
      className: "block-fullscreen has-custom-focus network-" + (idx + 1) + " progallery-svg-font-icons-" + network + (isSiteMode() || isSEOMode() ? '' : ' inactive '),
      style: {
        top: this.props.isVerticalContainer ? "calc(100% / 6 * " + (idx + 1) + " + -10px " + (shareIconsNumber === 4 ? '+ 100% / 12' : '') + ")" : '',
        left: this.props.isVerticalContainer ? '' : "calc(100% / 6 * " + (idx + 1) + " + -10px " + (shareIconsNumber === 4 ? '+ 100% / 12' : '') + ")"
      },
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        var shareData = {
          network: network,
          shareProps: allProps
        };

        _this2.props.actions.eventsListener(EVENTS.SHARE_BUTTON_CLICKED, shareData);
      },
      "data-hook": network + '-share-button',
      ref: function ref(button) {
        return _this2.buttons[idx] = button;
      },
      title: "Share on " + network,
      "aria-live": "assertive",
      tabIndex: -1,
      key: network + '-share-icon'
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        id = _this$props.id,
        isVerticalContainer = _this$props.isVerticalContainer,
        actions = _this$props.actions,
        style = _this$props.style,
        type = _this$props.type;

    if (styleParams.allowSocial) {
      var minDimension = 200;
      return React.createElement("div", {
        "data-hook": "social-share-box",
        className: 'block-fullscreen gallery-item-social-share-box ' + (this.props.showShare ? ' opened ' : ' hidden ') + (this.state.showShare ? ' hovered ' : '') + (isVerticalContainer ? ' vertical-item ' : ''),
        ref: function ref(e) {
          return _this3.socialShareBox = e;
        },
        onClick: function onClick(e) {
          return actions.toggleShare(e, false);
        },
        onMouseOut: function onMouseOut(e) {
          return actions.toggleShare(e, false);
        },
        style: {
          transform: isVerticalContainer ? 'translateY(-50%) ' + (style.height > minDimension ? '' : 'scale(' + style.height / minDimension + ')') : 'translateX(-50%) ' + (style.width > minDimension ? '' : 'scale(' + style.width / minDimension + ')')
        },
        tabIndex: styleParams.isSlideshow && this.props.currentIdx === this.props.idx ? 0 : -1,
        onKeyDown: function onKeyDown(e) {
          return _this3.handleKeyDown(e, type);
        },
        "aria-label": 'Share',
        role: "button",
        key: 'item-social-share-container-' + id
      }, this.shareArr.map(function (network, i) {
        return _this3.getShareItem(network, i);
      }));
    }

    return false;
  };

  return Share;
}(GalleryComponent);

export { Share as default };